import { useState } from 'react';
import PropTypes from 'prop-types';
import { Card } from '@mui/material';

import CustomTable from './Table';

const BatchListResults = ({
  batches = [],
  onEdit = () => {},
  onDelete = () => {},
  ...rest
}) => {
  const [page, setPage] = useState(0);

  const handlePageChange = (_, newPage) => {
    setPage(newPage);
  };

  return (
    <Card {...rest}>
      <CustomTable
        data={batches}
        dataKeysSequence={['_id', 'name', 'start_time', 'end_time', 'actions']}
        headers={['Batch Id', 'Name', 'Start Time', 'End Time', 'Actions']}
        handlePageChange={handlePageChange}
        page={page}
        onEdit={onEdit}
        onDelete={onDelete}
      />
    </Card>
  );
};

BatchListResults.propTypes = {
  batches: PropTypes.array.isRequired
};

export default BatchListResults;
